import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';

import { Outlet } from 'react-router-dom';
import Sidebar from '../sidebar/sidebar';
import Topbar from '../topbar/topbar';
import ModalWrapper from './components/modalWrapper/modalWrapper';

import './basicScreen.scss';

const BasicScreen: React.FC = () => {
  const expanded = useSelector((state: RootState) => state.sidebar.expanded);

  return (
    <div className={'basic-screen-wrapper'}>
      <Sidebar />
      <div className={`content-wrapper ${expanded === '1' ? 'expanded-sidebar-main-padding' : ''}`}>
        <Topbar />
        <Outlet />
      </div>
      <ModalWrapper />
    </div>
  );
};

export default BasicScreen;
